import axios from '@store/axios'
import * as firebase from 'firebase'
import clone from 'lodash/clone'
import parseUrl from '@/core/helpers/parseUrl'
import store from '@store'

firebase.initializeApp(process.env.FIREBASE_CONFIG)
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

export default {
  getUser({ commit }) {
    return axios.get('/user').then(({ data }) => {
      if (data) {
        commit('setUser', data)
      }
    })
  },
  setBranding({ commit }, { id }) {
    let partner = {}
    partner.id = id
    commit('setBrandingPartner', partner)
  },
  getUserSignature({ commit }) {
    return axios.get('/user/signature').then(({ data }) => {
      if (data) {
        commit('setUserSignature', data.url)
      }
    })
  },
  postUserSignature({ commit }, { sigData }) {
    return axios.post('user/signature', {
      pngBase64: sigData
    })
  },
  getUserGroups({ commit }) {
    return axios.get('/user/groups').then(({ data }) => {
      if (data) {
        let isProvider = false
        data.groups.forEach(group => {
          if (group.provider) {
            isProvider = true
          }
        })
        commit('setProviderUser', isProvider)
        commit('setUserGroups', data)
      }
    })
  },
  insertLog({ commit }, { actionTitle, detailTitle }) {
    let timeAppendage = '?time=' + new Date()
    let userAppendage = '&user='
    if (store.state.auth.authUser) {
      userAppendage = '&user=' + store.state.auth.authUser.email
    } else {
      userAppendage = userAppendage + 'unauthenticated'
    }
    let actionAppendage = '&action=' + actionTitle
    let detailAppendage = '&detail=' + detailTitle
    const url =
      'https://script.google.com/macros/s/AKfycbwS1Dpoocy8RzqYI8Fd1QuapPfLuGPsmKp8Ll4UH83nwW6p3FVP/exec' +
      timeAppendage +
      userAppendage +
      actionAppendage +
      detailAppendage
    return axios.get(url)
  },

  signUp({ commit, dispatch }, { email, password }) {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(user => {
          const authUser = {
            uid: user.uid,
            email: user.email
          }
          commit('setAuthUser', authUser)
          return resolve(authUser)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },

  affiliateThisUserWithProvider({ commit }, { providerID, affiliateCode }) {
    let payload = {}
    payload['affiliateCode'] = affiliateCode
    const url = parseUrl('/provider/:providerID/affiliate', { providerID })
    return axios.post(url, payload).then(({ data }) => {
      return data
    })
  },

  updatePassword({ commit, dispatch }, { password }) {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .currentUser.updatePassword(password)
        .then(
          () => {
            return resolve()
          },
          error => {
            return reject(error)
          }
        )
    })
  },

  signIn({ commit, dispatch }, { email, password }) {
    return new Promise((resolve, reject) => {
      return firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(user => {
          // set the timestamp of login for auto-logout functionality
          sessionStorage.setItem('login', new Date().getTime() / 1000)
          const authUser = {
            uid: user.uid,
            email: user.email
          }
          commit('setAuthUser', authUser)
          return resolve(authUser)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },

  check({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      if (state.authToken && state.authExpiry > Date.now()) {
        return resolve()
      }
      return dispatch('autoSignIn').then(resolve, reject)
    })
  },

  autoSignIn({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      // check if user is already authentication
      return firebase.auth().onAuthStateChanged(user => {
        if (user) {
          commit('setAuthUser', {
            uid: user.uid,
            email: user.email
          })
          // if user is authenticated
          if (user.email) {
            return dispatch('getAuthUserToken').then(resolve, reject)
          }
        } else {
          return reject(new Error('User not found'))
        }
      })
    })
  },

  getAuthUserToken({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      // get user token
      return firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(function (authToken) {
          commit('setAuthToken', authToken)
          return resolve()
        }, reject)
    })
  },

  resetPassword({ commit }, { email }) {
    return new Promise((resolve, reject) => {
      return firebase
        .auth()
        .sendPasswordResetEmail(email)
        .then(resolve)
        .catch(error => {
          commit('setError', error)
          reject(error)
        })
    })
  },

  signOut({ commit }) {
    commit('setAuthUser', null)
    commit('setAuthToken', null)
    return firebase.auth().signOut()
  },

  updateUser({ commit }, user) {
    const userCopy = clone(user)
    delete userCopy.authID
    return axios.patch('/user', userCopy).then(({ data }) => {
      commit('setUser', user)
      return data
    })
  },

  updateUserName({ commit }, { firstName, lastName }) {
    return axios
      .patch('/user', {
        firstName: firstName,
        lastName: lastName
      })
      .then(({ data }) => {
        commit('setUserName', { firstName: firstName, lastName: lastName })
        return data
      })
  },

  pay({ commit }, { token }) {
    return axios.post('/stripe/purchase', token).then(({ data }) => {
      return data
    })
  },

  checkAndUpdatePassword(
    { commit, dispatch },
    { currentPassword, newPassword }
  ) {
    if (currentPassword && newPassword) {
      firebase
        .auth()
        .currentUser.reauthenticateWithCredential(
          firebase.auth.EmailAuthProvider.credential(
            firebase.auth().currentUser.email,
            currentPassword
          )
        )
        .then(() => {
          dispatch('updatePassword', { password: newPassword }).then(() => {
            commit('setSuccess', 'Password Reset')
          })
        })
        .catch(error => {
          commit('setError', error)
        })
    }
  },
  uploadFile({ commit }, { file }) {
    // Create the path reference
    const ref = firebase.storage().ref()

    // Upload the file
    ref.put(file).then(uploadFile => {
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js